import { EProgramStatus } from '~/shared/enums/EProgramStatus';
import { EUnitProgramPeriodStatus } from '~/shared/enums/EUnitProgramPeriodStatus';
import {
  FetchHomeProgramsResponse,
  HomeProgramItem
} from '~/shared/types/fetchHomePrograms';

import { HOME_ACTION_CARD_TEMPLATES } from '../constants/homeActionCardTemplates';
import { HomeActionCardConfig, HomeActionCardTemplate } from '../types';

function isEligibleProductSalesProgram(program: HomeProgramItem): boolean {
  return (
    program.programStatus === EProgramStatus.IN_PROGRESS &&
    program.unitPeriodStatus === EUnitProgramPeriodStatus.PRODUCT_SALES &&
    program.isActiveProgram
  );
}

function hasEligibleProductSalesProgram(programs: HomeProgramItem[]): boolean {
  return programs.some(isEligibleProductSalesProgram);
}

function createCard(
  id: string,
  template: HomeActionCardTemplate,
  programId?: number
): HomeActionCardConfig {
  return {
    id,
    titleKey: template.titleKey,
    descriptionKey: template.descriptionKey,
    actionLabelKey: template.actionLabelKey,
    badge: template.badge,
    descriptionTitleKey: template.descriptionTitleKey,
    href: template.getHref(programId)
  };
}

export function buildHomeActionCards({
  isTeamManager,
  notifyPending,
  data
}: FetchHomeProgramsResponse): HomeActionCardConfig[] {
  const cards: HomeActionCardConfig[] = [];
  const hasEligibleSalesProgram = hasEligibleProductSalesProgram(data);

  for (const program of data) {
    switch (program.programStatus) {
      case EProgramStatus.CONFIGURATION:
        cards.push(
          createCard(
            `configuration-${program.idProgram}`,
            HOME_ACTION_CARD_TEMPLATES.configuration,
            program.idProgram
          )
        );
        break;
      case EProgramStatus.IN_PROGRESS:
        if (
          program.unitPeriodStatus === EUnitProgramPeriodStatus.STOCK_VALIDATION
        ) {
          cards.push(
            createCard(
              `stock-validation-${program.idProgram}`,
              notifyPending
                ? HOME_ACTION_CARD_TEMPLATES.stockValidationNotify
                : program.stockValidationDone
                  ? HOME_ACTION_CARD_TEMPLATES.stockValidationDone
                  : HOME_ACTION_CARD_TEMPLATES.stockValidationPending,
              program.idProgram
            )
          );
        }

        if (
          notifyPending &&
          program.unitPeriodStatus === EUnitProgramPeriodStatus.PRODUCT_SALES &&
          program.isActiveProgram
        ) {
          cards.push(
            createCard(
              `product-sales-notify-${program.idProgram}`,
              HOME_ACTION_CARD_TEMPLATES.productSalesNotify,
              program.idProgram
            )
          );
        }

        break;
      case EProgramStatus.CLOSING:
        cards.push(
          createCard(
            `program-closing-${program.idProgram}`,
            HOME_ACTION_CARD_TEMPLATES.programClosing,
            program.idProgram
          )
        );
        break;
      default:
        break;
    }
  }

  if (hasEligibleSalesProgram) {
    cards.push(createCard('my-order', HOME_ACTION_CARD_TEMPLATES.myOrder));
  }

  if (isTeamManager && hasEligibleSalesProgram) {
    cards.push(
      createCard('team-orders', HOME_ACTION_CARD_TEMPLATES.teamOrders)
    );
  }

  return cards;
}
